<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  type: {
    type: String,
    default: 'text'
  },
  id: {
    type: String,
    required: true
  },
  placeholder: {
    type: String,
    default: ''
  },
  required: {
    type: Boolean,
    default: false
  },
  icon: {
    type: String,
    default: 'user'
  }
});

const emit = defineEmits(['update:modelValue']);

const updateValue = (event) => {
  emit('update:modelValue', event.target.value);
};
</script>

<template>
  <div class="relative">
    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
      <font-awesome-icon :icon="['fas', icon]" class="h-5 w-5 text-emerald-500" />
    </div>
    <div class="absolute inset-y-0 left-10 flex items-center pointer-events-none">
      <div class="h-4 w-px bg-black/30"></div>
    </div>
    <input 
      :type="type"
      :id="id"
      :value="modelValue"
      @input="updateValue"
      :required="required"
      :placeholder="placeholder"
      class="block w-full rounded-md border-zinc-300 shadow-sm focus:outline-lime-400 sm:text-sm px-4 py-3 pl-12 bg-white"
    />
  </div>
</template>
